
import { StateCreator } from 'zustand';
import { UserState } from '@/store/slices/auth/userSlice';
import { PriceState } from './types';
import * as priceActions from './actions';
import { initializeFromSSR } from './actions/ssrActions';
import { TimePeriod } from '@/lib/metal-price';
import { GoldPurity, SilverPurity, Unit, calculateGoldPrice, calculateSilverPrice as calculateSilverPriceUtil } from '@/lib/pricing';
import { MetalPrice } from '@/lib/metal-price';

export type { PriceState } from './types';

export const createPriceSlice: StateCreator<
  PriceState & UserState,
  [],
  [],
  PriceState
> = (set, get) => ({
  currentGoldPrice: null,
  currentSilverPrice: null,
  goldPurity: '24KT',
  silverPurity: 'PURO',
  silverUnit: 'g',
  goldPriceHistory: [],
  silverPriceHistory: [],
  selectedTimePeriod: 'week',
  isPriceLoading: false,
  isHistoryLoading: false,
  error: null,
  priceAlerts: [],
  goldPrice: 0,
  silverPrice: 0,
  rawGoldPrice: null,
  rawSilverPrice: null,
  
  setSelectedTimePeriod: (period: TimePeriod) => {
    // Set the new time period.
    // The component observing this state will trigger the data fetch.
    set({ selectedTimePeriod: period });
  },
  
  setGoldPurity: (purity: GoldPurity) => priceActions.setGoldPurity(set, get, purity),
  setSilverPurity: (purity: SilverPurity) => priceActions.setSilverPurity(set, get, purity),
  setSilverUnit: (unit: Unit) => priceActions.setSilverUnit(set, get, unit),

  fetchCurrentPricesData: async () => {
    await priceActions.fetchCurrentPricesData(set, get);
    await priceActions.checkPriceAlerts(set, get);
  },
  
  fetchPriceHistoryData: async (period: TimePeriod) => {
    return await priceActions.fetchPriceHistoryData(set, period);
  },
  
  createPriceAlert: async (alert) => {
    const createdAlert = await priceActions.createPriceAlert(set, get, alert);
    return !!createdAlert;
  },
  
  togglePriceAlert: async (alertId) => {
    await priceActions.togglePriceAlert(set, get, alertId);
  },
  
  deletePriceAlert: async (alertId) => {
    await priceActions.deletePriceAlert(set, get, alertId);
  },

  loadUserPriceAlerts: async (userId) => {
    await priceActions.loadUserPriceAlerts(set, get, userId);
  },

  checkPriceAlerts: async () => {
    await priceActions.checkPriceAlerts(set, get);
  },

  // SSR initialization
  initializeFromSSR: () => {
    initializeFromSSR(set, get);
  },

  // @deprecated functions
  calculateGoldPrice: (rawPrice: MetalPrice, purity: GoldPurity): number => {
    if (!rawPrice) return 0;
    return calculateGoldPrice(rawPrice, purity);
  },
  calculateSilverPrice: (rawPrice: MetalPrice, purity: SilverPurity, unit: Unit): number => {
    if (!rawPrice) return 0;
    return calculateSilverPriceUtil(rawPrice, purity, unit);
  }
});
